import { clsx } from 'clsx';
export function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce(function (result, styles) {
    for (var _key2 in styles) {
      if (styles.hasOwnProperty(_key2)) {
        result[_key2] = clsx(result[_key2], styles[_key2]);
      }
    }
    return result;
  }, {});
}